/**
 * cus-waitlist-klaviyo.js
 *
 * Small helper for submitting waitlist signups directly to Klaviyo's
 * "Create Client Subscription" endpoint (public API, no private key needed).
 *
 * Docs: https://developers.klaviyo.com/en/reference/create_client_subscription
 *
 * Usage:
 *   window.CusKlaviyo.subscribe({
 *     publicApiKey: 'XXXXXX',       // Klaviyo "Site ID" / public API key
 *     listId: 'YOUR_LIST_ID',       // Klaviyo list ID to subscribe the profile to
 *     email: 'jane@example.com',
 *     firstName: 'Jane',            // optional
 *     lastName: 'Doe',              // optional
 *     phoneNumber: '+15551234567',  // optional, required only if subscribing to SMS
 *     properties: {                 // optional custom profile properties
 *       waitlist_product: 'Dual Calendar Mosaic MOP Edition',
 *       source_page: window.location.pathname
 *     },
 *     consentSMS: false             // set true to also opt-in to SMS marketing
 *   })
 *     .then(function () { ... success ... })
 *     .catch(function (err) { ... error ... });
 */

(function (window) {
  var KLAVIYO_ENDPOINT = "https://a.klaviyo.com/client/subscriptions/";
  var KLAVIYO_API_REVISION = "2026-04-15";

  function subscribe(options) {
    options = options || {};

    var publicApiKey = options.publicApiKey;
    var listId = options.listId;
    var email = options.email;

    if (!publicApiKey) {
      return Promise.reject(new Error("Missing Klaviyo publicApiKey."));
    }
    if (!listId) {
      return Promise.reject(new Error("Missing Klaviyo listId."));
    }
    if (!email) {
      return Promise.reject(new Error("Missing email address."));
    }

    var profileAttributes = {
      email: email,
    };

    if (options.firstName) profileAttributes.first_name = options.firstName;
    if (options.lastName) profileAttributes.last_name = options.lastName;
    if (options.phoneNumber)
      profileAttributes.phone_number = options.phoneNumber;
    if (options.properties) profileAttributes.properties = options.properties;

    // Subscriptions object tells Klaviyo which channels to opt the profile into.
    var subscriptions = {
      email: {
        marketing: {
          consent: "SUBSCRIBED",
        },
      },
    };

    if (options.consentSMS && options.phoneNumber) {
      subscriptions.sms = {
        marketing: {
          consent: "SUBSCRIBED",
        },
      };
    }

    profileAttributes.subscriptions = subscriptions;

    var body = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: profileAttributes,
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: listId,
            },
          },
        },
      },
    };

    var url =
      KLAVIYO_ENDPOINT + "?company_id=" + encodeURIComponent(publicApiKey);

    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        revision: KLAVIYO_API_REVISION,
      },
      body: JSON.stringify(body),
    }).then(function (response) {
      // Klaviyo returns 202 Accepted with an empty body on success.
      if (response.status === 202 || response.ok) {
        return true;
      }

      return response
        .json()
        .catch(function () {
          return {};
        })
        .then(function (data) {
          var message =
            (data && data.errors && data.errors[0] && data.errors[0].detail) ||
            "Something went wrong submitting the form. Please try again.";
          throw new Error(message);
        });
    });
  }

  window.CusKlaviyo = {
    subscribe: subscribe,
  };
})(window);
